export default __webpack_public_path__ + "static/media/logo_label_covid.6983ebec.svg";